// extracted by mini-css-extract-plugin
export default {"page":"ui-z","cartModal":"vi-z","checkout":"wi-z","placeholder":"xi-z","account":"yi-z"};